import type { Code } from "@/types/Codes";
import { SubdivisionListSchema, type Subdivision } from "@/types/Subdivision";
import axios from "axios";
import { buildUrl } from "./Utility";
import { errorApi } from "./ToastService";

export const getSubdivisions = async (userGroup: Code | null | undefined): Promise<Subdivision[]> => {
  let subdivisions: Subdivision[] = [];
  let params = new Map<string, string | number>();

  if (userGroup != null) {
    params.set("user-group", userGroup.num);
  }

  await axios
    .get(buildUrl("/subdivision/list", params))
    .then((response) => {
      subdivisions = SubdivisionListSchema.parse(response.data.result);
    })
    .catch((e) => errorApi(e));
  return subdivisions;
};
